export default "__VITE_ASSET__BGv2DOLC__"